// Tiny in-memory cache for reference/master data (metals, shapes, cuts, etc.)
// that many rows of the same form (e.g. one row per stone) would otherwise
// re-fetch identically. Caches the in-flight promise (not just the resolved
// value) so simultaneous mounts collapse into a single network call too.
export const createMasterDataCache = () => {
  const cache = new Map();

  const withCache = (key, fetcher) => {
    if (!cache.has(key)) {
      const promise = fetcher().catch((err) => {
        cache.delete(key);
        throw err;
      });
      cache.set(key, promise);
    }
    return cache.get(key);
  };

  const clear = (key) => {
    if (key === undefined) {
      cache.clear();
    } else {
      cache.delete(key);
    }
  };

  return { withCache, clear };
};
